import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withTheme } from '@material-ui/core';
import { FHEDivider } from 'data/components';
import renderEnvComponent from 'data/common/renderEnvComponent';
import DetailExpansionPanelRow from '../../../ProductModule/DetailExpansionPanelRow';

class AirzoneDetail extends Component {
    static propTypes = {
        history: PropTypes.object.isRequired,
        filteredProductModules: PropTypes.object.isRequired,
        productKey: PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {
            expanded: null
        };
    }

    handleChange = panel => {
        const { expanded } = this.state;
        this.setState({
            expanded: expanded === panel ? null : panel
        });
    };

    productModulesRender = lines => {
        const { productKey } = this.props;
        const { expanded } = this.state;
        let data = [];

        lines.forEach((line, key) => {
            data.push(
                <DetailExpansionPanelRow
                    key={key}
                    moduleKey={key}
                    expanded={expanded}
                    handleChange={this.handleChange.bind(this, key)}
                    line={line}
                    lineType={line.get('productType')}
                    lineLabel={line.get('label')}
                    productKey={productKey}
                />
            );
        });
        return data;
    };

    productModuleCategoriesRender = () => {
        const { filteredProductModules } = this.props;
        let data = [];

        filteredProductModules.forEach(lines => {
            data.push(this.productModulesRender(lines));
        });
        return data;
    };

    render() {
        const { history } = this.props;
        return (
            <Fragment>
                <FHEDivider title={Translator.translate(`general.productModules.airzoneModules`)} />
                {this.productModuleCategoriesRender()}
            </Fragment>
        );
    }
}

function productModulesFilter(productModules) {
    let filteredProductModules = new Map();
    productModules.map((productModule, productModuleKey) => {
        filteredProductModules = filteredProductModules.mergeIn([productModule.get('productType'), productModuleKey], productModule);
    });
    return filteredProductModules;
}

function mapStateToProps(state, props) {
    const { history } = props;
    const productKey = props.productKey;
    const product = state.environments[history.environment].data.Products.getIn(['list', productKey], new Map());
    const productModules = state.environments[history.environment].data.Products.getIn(['list', productKey, 'productModules'], new Map());
    return {
        productKey,
        productType: product.get('productType'),
        moduleType: product.get('type'),
        filteredProductModules: productModulesFilter(productModules)
    };
}

export default withRouter(
    renderEnvComponent('scenes/Products/components/Product/Fhe/Airzone/Airzone/index', connect(mapStateToProps)(withTheme(AirzoneDetail)))
);



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Airzone/Airzone/index.js